import { PayloadAction } from '@reduxjs/toolkit';
import { DTODiffusionModelsTablePageUD } from '@shared/dto/+diffusion_model/+ud/table/dto_diffusion_models_table_page_ud';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateMLAsset } from './state_ml_asset';

export const local_ml_asset_upsert_table_page = (payload: DTODiffusionModelsTablePageUD[]): PayloadAction<DTODiffusionModelsTablePageUD[]> => ({
  type: ENUM__redux_action.ML_ASSET_UPSERT_TABLE_PAGE,
  payload,
});

export function init_local_ml_asset_upsert_table_page(state: StateMLAsset, action: PayloadAction<DTODiffusionModelsTablePageUD[]>) {
  if (action.payload.length == 0) return;

  for (let page of action.payload) {
    let { hash_crc32_settings_table, hash_crc32_settings_table_page } = page;

    state.page_settings_loading_in_progress.delete(hash_crc32_settings_table_page);

    //need for force re-render
    state.page_settings_loading_in_progress = new Set(state.page_settings_loading_in_progress);

    let table = state.tables_map.get_or_assert(hash_crc32_settings_table);
    table.add_page(page);

    //need for force re-render
    state.tables_map = new Map(state.tables_map);

    if (state.current_table.hash_crc32_settings_table == hash_crc32_settings_table) {
      state.current_table.add_page(page);
      //need for force re-render
      state.current_table = state.current_table.clone();
    }
  }
}
